// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2Hr0W","heading":"styles_heading__1fMSK","profitText":"styles_profitText__19Knv"};